import {createFileRoute} from '@tanstack/react-router';

import ManagedEventsView from '../../user/ManagedEventsView.tsx';

export const Route = createFileRoute('/_app/managed-events')({
    component: RouteComponent,
});

function RouteComponent() {
    return <ManagedEventsView />;
}
